import React from 'react';
import { Schema } from 'src/components/Schema/Schema';
import { ORGANIZATION_ID, breadcrumbSchemaId } from 'src/constants/schema';

export interface SubcategoryLink {
    name: string;
    url: string;
}

export interface BreadcrumbEntry {
    name: string;
    url: string;
}

type Props = {
    name: string;
    description: string;
    canonicalUrl: string;
    breadcrumbs: BreadcrumbEntry[];
    subcategories: SubcategoryLink[];
};

export const CategoryLandingStructuredData: React.FC<Props> = ({
    name,
    description,
    canonicalUrl,
    breadcrumbs,
    subcategories,
}) => (
    <>
        {breadcrumbs.length > 0 && (
            <Schema
                input={{
                    '@context': 'https://schema.org',
                    '@type': 'BreadcrumbList',
                    '@id': breadcrumbSchemaId(canonicalUrl),
                    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
                        '@type': 'ListItem',
                        position: index + 1,
                        name: breadcrumb.name,
                        item: breadcrumb.url,
                    })),
                }}
            />
        )}
        <Schema
            input={{
                '@context': 'https://schema.org',
                '@type': 'CollectionPage',
                name,
                description,
                url: canonicalUrl,
                publisher: { '@type': 'Organization', '@id': ORGANIZATION_ID },
            }}
        />
        {subcategories.length > 0 && (
            <Schema
                input={{
                    '@context': 'https://schema.org',
                    '@type': 'ItemList',
                    itemListElement: subcategories.map((subcategory, index) => ({
                        '@type': 'ListItem',
                        position: index + 1,
                        name: subcategory.name,
                        url: subcategory.url,
                    })),
                }}
            />
        )}
    </>
);
